import beelineLogo from 'app/images/operators/beeline.svg';
import megafonLogo from 'app/images/operators/megafon.svg';
import mtsLogo from 'app/images/operators/mts.svg';
import rostelecomLogo from 'app/images/operators/rostelecom.svg';
import t2Logo from 'app/images/operators/t2.svg';
import yotaLogo from 'app/images/operators/yota.png';
const MCC_RUSSIA = 250;
const MTS = { name: 'МТС', logo: mtsLogo };
const MEGAFON = { name: 'МегаФон', logo: megafonLogo };
const BEELINE = { name: 'Билайн', logo: beelineLogo };
const T2 = { name: 'T2', logo: t2Logo };
const YOTA = { name: 'Yota', logo: yotaLogo };
const ROSTELECOM = { name: 'Ростелеком', logo: rostelecomLogo };
/** MNC операторов РФ (MCC 250). */
const russianOperators = {
    1: MTS,
    2: MEGAFON,
    11: YOTA,
    20: T2,
    28: BEELINE,
    39: ROSTELECOM,
    99: BEELINE,
};
const toCode = (value) => {
    if (value === null || value === undefined || value === '' || value === 'NA') {
        return null;
    }
    const code = Number(value);
    return Number.isInteger(code) && code >= 0 ? code : null;
};
/** Оператор GSM по MCC/MNC из телеметрии; null, если коды отсутствуют или оператор неизвестен. */
export function getGsmOperator(mcc, mnc) {
    const mccCode = toCode(mcc);
    const mncCode = toCode(mnc);
    if (mccCode !== MCC_RUSSIA || mncCode === null) {
        return null;
    }
    const operator = russianOperators[mncCode];
    return operator ? Object.assign(Object.assign({}, operator), { mcc: mccCode, mnc: mncCode }) : null;
}
